import { useMemo } from 'react';

import { ALL_PROJECTS_VALUE } from 'domains/projects/const';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAppSelector } from 'store/useAppSelector';

import { PRIMARY_JWT_INDEX } from '../const';
import { selectTokenManagerConfig } from '../store/selectors';
import { useJWTManagerPermissions } from './useJWTManagerPermissions';

// TODO: refactor token selection logic
export const useTokenManagerConfigSelector = () => {
  const { accountAddress = '' } = useAccount();

  const config = useAppSelector(state =>
    selectTokenManagerConfig(state, accountAddress),
  );

  const { hasReadAccess: shouldShowTokenManager } = useJWTManagerPermissions();

  // TODO: move selectedProjectEndpointToken out of this hook and remove selectedProject from config.
  // config.selectedProject is used for project selectors in analytics
  const selectedProjectEndpointToken = useMemo(() => {
    if (config.selectedProject === ALL_PROJECTS_VALUE) return undefined;

    return config.selectedProject;
  }, [config]);

  return {
    ...config,
    selectedProjectEndpointToken,
    address: accountAddress,
    tokenIndex: config.tokenIndex || PRIMARY_JWT_INDEX,
    shouldShowTokenManager,
  };
};
